import React from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { red } from "../../../../utils/colors";
import Image from "../../Image";
import LinkComponent from "../../LinkComponent";
import Markdown from "../../Markdown";
import ShapePartLeft from "../../ShapeContainer/ShapePartLeft";
import HeadlineItem from "../ContentElement/HeadlineItem";
import { SideNavContainer } from "../SideNavContainer";
import useSideNavStore from "../SideNavContainer/store";
import ImgShape from "./ImgShape";

const Container = styled.div`
    width: 100%;
    position: relative;
    margin: 100px 0;
    height: unset;
    ${({ theme }) => theme.breakpoints.from.small.css`
         height: 80vh;
    `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
         height: 60vh;
    `}
    ${({ theme }) => theme.breakpoints.from.normal.css`
         height: 50vh;
    `}
`;

const LeftContainer = styled.div`
    position: unset;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.red.toString()};
    z-index: 2;
    top: 0;
    bottom: 100px;
    left: 0;
    ${({ theme }) => css`
        ${theme.breakpoints.from.small.css`
            position: absolute;
            height: 45%;
            background-color: transparent;
        `};
        ${theme.breakpoints.from.medium.css`
            width: 60%;
            height: 100%;
        `};
    `}
`;

const ShapeContainer = styled.div`
    z-index: 0;
    position: absolute;
    display: none;
    height: 100%;
    width: 100%;
    ${({ theme }) => theme.breakpoints.from.small.css`
        display: flex;
    `}
`;

const FillContainer = styled.div`
    flex-grow: 1;
    background-color: ${red};
`;

const Shape = styled.div`
    position: relative;
    left: -1px;
    width: auto;
    height: 100%;

    svg {
        width: auto;
        height: 100%;
        transform: rotate(180deg);
    }
`;
const TextContainer = styled.div`
    z-index: 1;
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    ${({ theme }) => css`
        ${theme.paddings.containerOuter.top};
        ${theme.paddings.containerOuter.left};
        ${theme.paddings.containerOuter.right};
        ${theme.paddings.containerOuter.bottom};

        color: ${theme.colors.white.toString()};
        ${theme.breakpoints.from.small.css`
            position: absolute;
            padding-right: 100px;
            padding-bottom: unset;
        `};
        ${theme.breakpoints.from.medium.css`
            padding-top: 50px;
            padding-right: 100px;
        `};
    `}
`;

const Text = styled(Markdown)`
    padding: 15px 10px 15px 0;
    margin-bottom: 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const RightContainer = styled.div`
    position: absolute;
    align-self: flex-end;
    width: 95%;
    z-index: 0;
    overflow: hidden;
    right: 0;
    bottom: 0;
    top: 35%;
    height: 50%;
    display: none;
    ${({ theme }) => css`
        ${theme.breakpoints.from.small.css`
            display: block;
        `}
        ${theme.breakpoints.from.medium.css`
            top: 10%;
            width: 50%;
            height: 100%;
        `};
    `}
`;

const ImgStyle = css`
    width: auto;
    height: 100%;
`;

const ImgFilter = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    height: 100.4%;

    svg {
        width: auto;
        height: 100%;
    }
`;

const Img = styled.img``;

const ShapeOverImg = ({ name, text, link, image, imgUrl, headlineNumber }) => {
    const theme = useTheme();
    const [paddingLeft] = useSideNavStore((state) => [state.paddingLeft]);
    const headlineStyles = css`
        ${theme.breakpoints.from.small.css`
            margin-right: -80px;
        `}
    `;

    return (
        <Container>
            <LeftContainer>
                <TextContainer>
                    <SideNavContainer paddingLeft={paddingLeft}>
                        <HeadlineItem
                            headline={headlineNumber}
                            color="white"
                            fSExtraSmall="1.5rem"
                            fontSize="3rem"
                            css={headlineStyles}
                        >
                            {name}
                        </HeadlineItem>
                        <Text>{text}</Text>
                        <LinkComponent
                            color="white"
                            link={{ href: link.href, text: link.text }}
                            fSExtraSmall="1rem"
                            fSSmall="1rem"
                            fontSize="1.5rem"
                            icon="arrow-right"
                        />
                    </SideNavContainer>
                </TextContainer>
                <ShapeContainer>
                    <FillContainer />
                    <Shape>
                        <ShapePartLeft color={red} />
                    </Shape>
                </ShapeContainer>
            </LeftContainer>
            <RightContainer>
                <ImgFilter>
                    <ImgShape />
                </ImgFilter>
                {image?.src && <Image css={ImgStyle} {...image} />}
                {imgUrl && <Img src={imgUrl} alt={imgUrl} />}
            </RightContainer>
        </Container>
    );
};

export default ShapeOverImg;
